export const GUARANTEE_TEXT =
  "We’re the marketplace members can trust. Our guarantee covers all orders for the first year after purchase.";

export const GUARANTEE_ITEMS = [
  {
    label: "How is my order secure?",
    text: "We encrypt the transfer of sensitive data and never store credit card information."
  },
  {
    label: "How is GCX Cash Applied?",
    text: "GCX Cash is applied in full. However, for each order total that is equal to or less than the amount of available GCX Cash, you will be required to pay $1 out of pocket. Any remaining GCX Cash will be saved for future orders according to the expiration terms of the GCX Cash earned."
  },
  {
    label: "What is the 90 Day Money-Back guarantee?",
    text: "All orders on our marketplace are backed by our 90 Day Money-Back Guarantee. In the event a gift card cannot be redeemed as indicated, we will refund the purchase price of the card, not any discount or savings the buyer received. Please visit our guarantee page for a full list of what's covered under this policy."
  }
];
